import * as ng from 'angular';
import { DropboxSaverService } from '../../../services/dropbox-saver.service';

declare var Dropbox: any;

export const DropboxSaver = (DropboxSaverService: DropboxSaverService, store: ng.a0.storage.IStoreService, $rootScope: any) => (<angular.IDirective>{

    restrict: 'E',
    template: '<div id="dropbox-saver-container></div>',
    scope: {
        options: '&',
        methodType: '@',
        selectedItems: '=',
        getFiles: '&'
    },
    link: (scope: any, element: JQLite, attrs: any) => {

        let defaultOptions: any = {
            success: () => {
                // ?
            },
            progress: (progress) => {
                // ?
            },
            cancel: () => {
                // ?
            },
            error: (error) => {
                // ?
            }
        };

        let createSaveButton = (options: any, url?: any, filename?: any) => {
            let button: any;

            if (url !== undefined) {
                if (filename !== undefined) {
                    button = Dropbox.createSaveButton(url, filename, options);
                } else {
                    button = Dropbox.createSaveButton(url, options);
                }

            } else {
                button = Dropbox.createSaveButton(options);
            }

            return button;
        };

        let appendButton = (button) => {
            let element = document.getElementById('dropbox-saver-container');


            if (element.childNodes[0] !== undefined) {
                element.removeChild(element.childNodes[0]);
            }

            element.appendChild(button);
        };

        scope.uploadMultipleFiles = (options) => {
            if (options === undefined) {
                options = defaultOptions;
            }

            let button = createSaveButton(options);
            appendButton(button);
        };

        scope.uploadSingleFile = (url, filename, options) => {
            let button = createSaveButton(options, url, filename);
            appendButton(button);
        };

        let createButton = (token, newValue) => {

            if (newValue.length === 1) {
                let file = scope.getFiles()[0];
                let url = 'https://storage.googleapis.com/' + file.storage_path.split(' ').join('%20') + '?access_token=' + token;
                let filename = file.name.split(' ').join('%20');

                if (filename !== undefined) {
                    filename = 'ArchiSMALL/' + filename;
                }

                scope.uploadSingleFile(url, filename, defaultOptions);
            } else if (newValue.length > 1) {

                let files = scope.getFiles();
                defaultOptions.files = DropboxSaverService.setOptionsFiles(files);
                scope.uploadMultipleFiles(defaultOptions);
            }
        };

        scope.$watch('selectedItems', (newValue, oldValue) => {
            if (newValue !== undefined) {
                var token = store.get('_GoogleAccessToken');

                if (token == null) {
                    $rootScope.generateGoogleAPIToken()
                        .then((response) => {
                            store.set('_GoogleAccessToken', response.accessToken);
                            token = response.accessToken;
                            createButton(token, newValue);
                        });
                } else {
                    $rootScope.validateGoogleAPIToken(token)
                        .then(() => {
                            createButton(token, newValue);
                        })
                        .catch(() => {
                            $rootScope.generateGoogleAPIToken()
                                .then((response) => {
                                    store.set('_GoogleAccessToken', response.accessToken);
                                    token = response.accessToken;
                                    createButton(token, newValue);
                                });
                        });
                }
            }
        });

    }
});

DropboxSaver.$inject = ['DropboxSaverService', 'store', '$rootScope'];



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/dropbox-saver/dropbox-saver.directive.ts